import { get } from 'lodash';
import moment from 'moment-timezone';

import accessTokenStorage from 'containers/services/security/access-token-storage';
import currentUserStorage, {
  Privileges,
} from 'containers/services/security/current-user-storage';
import OverLayStorage from 'containers/services/security/overlay-storage';

export interface LoginResponse {
  success: boolean;
  data: {
    access_token: string;
    username: string;
    experitationPeriod: number;
    privileges: Privileges;
  };
}

const storeLoginData = (loginResponse: LoginResponse) => {
  const data = get(loginResponse, 'data');

  if (data) {
    accessTokenStorage.set({
      token: get(data, 'access_token'),
      loginDate: moment().format(),
      experitationPeriod: get(data, 'experitationPeriod'),
    });
    currentUserStorage.set({
      username: get(data, 'username'),
      privileges: get(data, 'privileges'),
      subservices: get(data, 'subservices'),
    });
  }
};

const clearLoginData = () => {
  accessTokenStorage.clear();
  currentUserStorage.clear();
  OverLayStorage.clear();
};

const storageServices = {
  storeLoginData,
  clearLoginData,
};

export default storageServices;
